import React from "react"

import BookTrip from "~components/pages/book/book-trip"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"

export default function CheckoutFlowPaymentStep() {
    const { checkoutQueryParams } = useCheckoutFlow()

    return <BookTrip quoteId={checkoutQueryParams.quote_id} />
}
